import * as React from "react";
import { getLocalizedString } from "./LocalizedText";
import { getGlobalClassNames, getTheme, mergeStyles, useTheme } from "@fluentui/react";
import { useStringsSanitizer } from "../../hooks";
import { TrustedHtmlComponent } from "../TrustedHtmlComponent";
import { DescriptionFieldProps } from "@rjsf/utils";

const theme = getTheme();

const classNames = getGlobalClassNames(
  {
    description: "field-description",
  },
  theme
);

/**
 * The description field component.
 *
 * @param props - The component properties.
 * @returns - the markup.
 */
export const DescriptionField: React.FC<DescriptionFieldProps> = (props) => {
  const { id, description } = props;
  const policy = useStringsSanitizer();
  const currentTheme = useTheme();
  const descriptionStyle = mergeStyles(classNames.description, currentTheme.fonts.small, {
    color: currentTheme.semanticColors.bodyText,
    selectors: {
      a: {
        color: "var(--rca-link-color)",
        textDecorationColor: "currentColor",
      },
      "a:visited": {
        color: "var(--rca-link-color)",
      },
      "a:hover": {
        color: "var(--rca-link-hover-color)",
      },
      "a:focus": {
        color: "var(--rca-link-hover-color)",
      },
    },
  });
  if (!description) {
    return null;
  }
  if (typeof description === "string") {
    const localizedDescription = getLocalizedString(description);
    return <TrustedHtmlComponent id={id} tagName="p" className={descriptionStyle} trustedHtml={policy.createHTML(localizedDescription)} />;
  } else {
    return (
      <div id={id} className={descriptionStyle}>
        {description}
      </div>
    );
  }
};
